// Единый лимит размера вложения (использует и App.vue, и DragAndDropUploader.vue).
export const MAX_FILE_SIZE = 250 * 1024 * 1024;
export const MAX_FILE_SIZE_LABEL = '250 МБ';
